/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import FileDropper from 'shared/ui/components/form-components/pickers/FileDropper.vue';

// Mixins
import workerStarter from './worker-starter';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';

const __vue_script__ = {
    name: 'UploadModal',

    components: {
        FileDropper,
        Toggler
    },

    mixins: [workerStarter],

    props: {
        data: {
            type: Object,
            required: true
        },

        acceptedMimes: {
            type: Array,
            default: () => []
        },

        supportedMimes: {
            type: Array,
            default: () => []
        },

        modalTitle: {
            type: String,
            default: ''
        },

        modalSubtitle: {
            type: String,
            default: ''
        },

        modalWarning: {
            type: String,
            default: ''
        },

        maxSize: {
            type: Number,
            required: true
        },

        subtitleAsHtml: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            files: []
        };
    },

    computed: {
        isVideoUpload() {
            return this.acceptedMimes?.includes('video/mp4') ?? false;
        }
    },

    methods: {
        /**
         * Closes the modal
         */
        close() {
            this.$emit('close');
        },

        /**
         * Callback called when the worker has started
         */
        onAfterStart() {
            this.close();
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-wrapper uploader"},[_c('div',{staticClass:"modal-header"},[_c('a',{staticClass:"close",on:{"click":function($event){return _vm.close()}}}),_c('h3',[_vm._v(_vm._s(_vm.modalTitle || _vm.$t('general.upload')))])]),(_vm.modalWarning)?_c('div',{staticClass:"hint alert alert-warning"},[_c('p',[_vm._v(_vm._s(_vm.modalWarning))])]):_vm._e(),(_vm.isVideoUpload)?_c('div',{staticClass:"hint alert alert-info"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('live_sessions.video_library.hint_title')))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('live_sessions.video_library.hint_subtitle'))}})]):_vm._e(),_c('div',{staticClass:"modal-body"},[(_vm.modalSubtitle)?_c('div',{staticClass:"subtitle"},[(_vm.subtitleAsHtml)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.modalSubtitle)}}):[_vm._v(_vm._s(_vm.modalSubtitle))]],2):_vm._e(),_c('file-dropper',{attrs:{"accepted-mimes":_vm.acceptedMimes,"supported-mimes":_vm.supportedMimes,"max-size":_vm.maxSize},on:{"input":_vm.startUpload}})],1),(_vm.isVideoUpload)?_c('toggler',{staticClass:"email-notification",attrs:{"name":"live_sessions.video_library.send_email_notification","on-label":"live_sessions.video_library.send_email_notification","off-label":"live_sessions.video_library.send_email_notification"},model:{value:(_vm.sendEmailNotification),callback:function ($$v) {_vm.sendEmailNotification=$$v},expression:"sendEmailNotification"}}):_vm._e(),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.close()}}},[_vm._v(_vm._s(_vm.$t('general.close')))])])],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "UploadModal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__